import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { select, Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import {
  Observable,
  Subject,
  of,
  concat,
  Subscription,
  BehaviorSubject,
} from 'rxjs';
import {
  distinctUntilChanged,
  switchMap,
  catchError,
  tap,
  map,
  debounceTime,
} from 'rxjs/operators';
import Swal from 'sweetalert2';

import { currentUser } from '@app/core/auth';
import { ClientPurchaseOrderService } from '@app/core/client/services/client-purchase-order.service';
import { ClientUsersService } from '@app/core/client/services/client-users.service';
import { ClientService } from '@app/core/client/services/client.service';
import { FactoryService } from '@app/core/factories';
import { KitService } from '@app/core/kits/services/kit.service';
import { PipelineService } from '@app/core/pipelines/services/pipeline.service';
import { ProductTagService } from '@app/core/product-tags/services/product-tag.service';
import { CategoryService } from '@app/core/products/services/category.service';
import { ProjectTypeService } from '@app/core/project-types/services/project-type.service';
import { PoService } from '@app/core/purchase-orders/services/po.service';
import { RfqService } from '@app/core/quotes';
import { ProductDesignService } from '@app/core/quotes/services/product-design.service';
import { AppState } from '@app/core/reducers';
import { SettingsService } from '@app/core/settings/services/settings.service';
import { StaffService } from '@app/core/staff';
import { ClientPurchaseOrderPopupFormComponent } from '@app/modules/clients/client-purchase-order-popup-form/client-purchase-order-popup-form.component';
import { PopupFormComponent as ClientUserPopupForm } from '@app/modules/clients/popup-form/popup-form.component';
import { AuthFormModalComponent as FactoryModalComponent } from '@app/modules/factories/form-modal/form-modal.component';
import { ClientFormComponent } from '@app/shared/components/client-form/client-form.component';
import { PurchaseOrderFormComponent } from '@app/shared/components/purchase-orders/purchase-order-form/purchase-order-form.component';

import { CreateClientRfqComponent } from '../../create-client-rfq/create-client-rfq.component';

@Component({
  selector: 'cnc-nd-popup-form',
  templateUrl: './nd-popup-form.component.html',
  styleUrls: ['./nd-popup-form.component.scss'],
})
export class NdPopupFormComponent implements OnInit {
  // sku
  rfq$ :Observable<any[]>;
  rfqLoading = false;
  rfqInput$ = new Subject<string>();
  rfqProduct :any;

  // kits
  kit$ :Observable<any[]>;
  kitLoading = false;
  kitInput$ = new Subject<string>();

  // clients
  client$ :Observable<any[]>;
  clientLoading = false;
  clientInput$ = new Subject<string>();

  // po
  purchaseOrder$ :Observable<any[]>;
  purchaseOrderLoading = false;
  purchaseOrderInput$ = new Subject<string>();

  // client po
  clientPo$ :Observable<any[]>;
  clientPoLoading = false;
  clientPoInput$ = new Subject<string>();

  // client user
  clientUser$ :Observable<any[]>;
  clientUserLoading = false;
  clientUserInput$ = new Subject<string>();

  // factories
  factory$ :Observable<any[]>;
  factoryLoading = false;
  factoryInput$ = new Subject<string>();

  pipelines :any = [];
  designPipelines :any = [];

  loading :boolean;
  pageTitle :string = 'New Task';
  link :'';
  filesToUpload :any[] = [];
  linksToUpload :any[] = [];

  tags :any = [];
  selectedTags :any = [];

  subtask_form_handler :any = [];

  staticTags :any = [];

  @Input() kitRfqs :any;
  @Input() design :any;
  @Input() activePipeline :any;
  formData :any = {};

  private readonly _kitRfqs = new BehaviorSubject<any>(<any>[]);
  public kitRfqs$ = this._kitRfqs.asObservable();

  tabIndex :number = 0;

  selected :any = {
    kits: null,
    rfqs: null,
    clients: null,
    purchase_orders: null,
    client_purchase_orders: null,
    client_users: null,
  };

  activeDescriptionTab :number = 0;

  projectTypes :any = [];

  invalidDueDate :boolean = false;

  selectedCategory :any;

  constructor(
    public activeModal :NgbActiveModal,
    public pipelineSvc :PipelineService,
    public translate :TranslateService,
    private rfqSvc :RfqService,
    private productDesignSvc :ProductDesignService,
    private toastr :ToastrService,
    public staffSvc :StaffService,
    private cd :ChangeDetectorRef,
    public tagSvc :ProductTagService,
    private modalSvc :NgbModal,
    private kitSvc :KitService,
    private clientSvc :ClientService,
    private poService :PoService,
    private clientPoService :ClientPurchaseOrderService,
    private clientUserService :ClientUsersService,
    private factoryService :FactoryService,
    public projectTypeSvc :ProjectTypeService,
    public productCategoriesSvc :CategoryService,
    private settingsSvc :SettingsService,
    private store :Store<AppState>,
  ) {}

  ngOnInit() {
    this.loadRfqs();
    this.loadProjectTypes();

    this.formData.linked_modules = {
      rfqs: [],
      kits: [],
      clients: [],
      purchase_orders: [],
      client_purchase_orders: [],
      client_users: [],
      factories: [],
    };

    this.formData.additional_descriptions = [];

    // set default assignee
    this.store.pipe(select(currentUser)).subscribe((user) => {
      if (!(this.design && this.design.id)) {
        this.formData.assigned_users = [user.id];
      }
    });

    if (this.design && this.design.id) {
      this.pageTitle = 'Edit Task';

      this.productDesignSvc.getById(this.design.id).subscribe((resp) => {
        if (resp && resp.id) {
          this.design = resp;
          try {
            this.design.assigned_subtasks.map((obj) => ({
              ...obj,
              editable: false,
            }));
            this.design.assigned_skus.map((data) =>
              data.filter((x) => x.item != null),
            );
          } catch (e) {}
          this.formData = {
            ...this.formData,
            master_sku: this.design.rfq,
            reference_id: this.design.reference_id,
            design_name: this.design.design_name,
            description: this.design.description,
            attachments: this.design.attachments,
            assigned_users: this.design.assigned_users,
            design_priority: this.design.design_priority,
            assigned_skus: this.design.assigned_skus,
            assigned_tags: this.design.assigned_tags,
            assigned_subtasks: this.design.assigned_subtasks,
            project_type_id: this.design.project_type_id,
            category_id: this.design.category_id,
          };

          if (this.design.category_id) {
            this.getSubCategories();
            this.formData.subcategory_id = this.design.subcategory_id;
          }

          if (this.design.due_date) {
            this.formData.due_date = this.design.due_date;
          }

          if (this.design.assigned_tags) {
            const tagIds :any[] = this.design.assigned_tags.map((r) => r.tag_id);
            this.formData.assigned_tags = tagIds;
          }

          if (this.design.assigned_subtasks) {
            this.formData.assigned_subtasks.map((obj) => ({
              ...obj,
              editable: false,
            }));
          }

          this.subtask_form_handler = JSON.parse(
            JSON.stringify(this.formData.assigned_subtasks),
          );

          if (this.design.assigned_users) {
            const memberIds :any[] = this.design.assigned_users.map(
              (r) => r.user_id,
            );
            this.formData.assigned_users = memberIds;
          }

          if (this.design.assigned_skus) {
            const rfqIds :any[] = this.design.assigned_skus
              .map((r) => {
                return {
                  id: r.item_id,
                  is_kit: r.type == 'kit' ? 1 : 0,
                  product_name:
                    r.type == 'kit' ? r.item.title : r.item.product_name,
                  sku: r.type == 'kit' ? r.item.sku : r.item.internal_sku,
                };
              })
              .filter((id) => id != 0);
            // this.loadSelectedRfqs(rfqIds.join(','));
            this.formData.assigned_skus = rfqIds;
          }

          this.formData.linked_modules = {
            ...this.formData.linked_modules,
            rfqs: this.design.linked_rfqs ? this.design.linked_rfqs : [],
            kits: this.design.linked_kits ? this.design.linked_kits : [],
            clients: this.design.linked_clients ? this.design.linked_clients : [],
            purchase_orders: this.design.linked_purchase_orders
              ? this.design.linked_purchase_orders
              : [],
            client_purchase_orders: this.design.linked_client_purchase_orders
              ? this.design.linked_client_purchase_orders
              : [],
            client_users: this.design.linked_client_users
              ? this.design.linked_client_users
              : [],
            factories: this.design.linked_factories
              ? this.design.linked_factories
              : [],
          };

          this.linksToUpload = this.design.links;

          this.design.additional_descriptions.forEach((e) => {
            this.addDescription(e);
          });
        }
        this.setStaticTags();
        this.cd.detectChanges();
      });
    }

    this.pipelineSvc.pipelines$.subscribe((pipelines) => {
      if (pipelines && pipelines.data) {
        // this.pipelines = pipelines.data.filter((row) => row.pipeline_type == 2);
        this.pipelines = pipelines.data;
        if (this.design) {
          if (this.design.pipelines && this.design.pipelines.length > 0) {
            this.design.pipelines.forEach((p) => {
              const pipeline = this.pipelines.find(
                (row) => row.id == p.pipeline_id,
              );
              if (pipeline) {
                this.addPipeline({
                  pipeline_id: p.pipeline_id,
                  pipeline_stage_id: p.pipeline_stage_id,
                  priority: p.priority,
                  stages: pipeline.stages,
                });
              }
            });
          }
        } else {
          if (this.activePipeline && this.activePipeline.id) {
            if (
              this.activePipeline.stages &&
              this.activePipeline.stages.length > 0
            ) {
              this.addPipeline({
                pipeline_id: this.activePipeline.id,
                pipeline_stage_id: this.activePipeline.stages[0].id,
                priority: 10,
                stages: this.activePipeline.stages,
              });
            }
          } else {
            this.addPipeline();
          }
        }
      }
    });

    this.tagSvc.formattedRecord$
      .subscribe((tags :any) => {
        this.tags = tags;
        this.getStaticTags();
      })
      .unsubscribe();
    this.tagSvc.getTags({ parent_only: true }, null);
  }

  setStaticTags() {
    if (
      this.design &&
      this.design.static_tags &&
      this.staticTags &&
      this.staticTags.length > 0
    ) {
      this.staticTags.forEach((staticTag :any) => {
        staticTag.selectedValues = this.design.static_tags
          .filter((row) => row.static_tag_id == staticTag.id)
          .map((row) => row.tag_id);
      });
    }
  }

  getStaticTags() {
    this.settingsSvc.getProjectManagementSettings().subscribe((resp :any) => {
      if (resp && resp.id) {
        this.staticTags = [];
        const settings = JSON.parse(resp.value);
        if (settings.static_tag_ids && settings.static_tag_ids.length > 0) {
          // staticTags
          settings.static_tag_ids.forEach((tagId) => {
            const tag = this.tags.find((row) => row.id == tagId);
            if (tag && tag.id) {
              const newTag = Object.assign({}, tag);
              newTag.children = this.tagSvc.formatHList([], newTag, 0, false);
              this.staticTags.push(newTag);
            }
          });
        }
        this.setStaticTags();
      }
    });
  }

  loadProjectTypes() {
    this.projectTypeSvc.record$.subscribe((res) => {
      this.projectTypes = res;
    });
  }

  saveDesign() {
    if (!this.formData.design_name) {
      Swal.fire('Form error!', 'Task Name is required.', 'error');

      return;
    }

    const fd = new FormData();
    fd.append('rfq_id', '0');
    fd.append('master_sku', '');
    fd.append('reference_id', this.formData.reference_id || '');
    fd.append('design_name', this.formData.design_name || '');
    fd.append('due_date', this.formData.due_date || '');
    fd.append('description', this.formData.description || '');
    fd.append('links', JSON.stringify(this.linksToUpload));
    fd.append('design_priority', this.formData.design_priority);
    fd.append('assigned_users', this.formData.assigned_users || []);
    fd.append('assigned_tags', this.formData.assigned_tags || []);
    fd.append(
      'additional_descriptions',
      JSON.stringify(this.formData.additional_descriptions),
    );
    fd.append('project_type_id', this.formData.project_type_id || '');
    fd.append('category_id', this.formData.category_id || '');
    fd.append('subcategory_id', this.formData.subcategory_id || '');

    let assigned_skus = [];
    if (this.formData.assigned_skus && this.formData.assigned_skus.length > 0) {
      assigned_skus = this.formData.assigned_skus.map((row) => {
        return {
          item_id: row.id,
          is_kit: row.is_kit,
        };
      });
    }
    fd.append('assigned_skus', JSON.stringify(assigned_skus));

    const linked_modules = JSON.parse(JSON.stringify(this.formData.linked_modules)); // deep copy
    [
      'kits',
      'rfqs',
      'clients',
      'purchase_orders',
      'client_purchase_orders',
      'client_users',
      'factories',
    ].forEach((module) => {
      linked_modules[module] = linked_modules[module].reduce((acc, curr) => {
        return {
          ...acc,
          [parseInt(curr.id)]: { remarks: curr.pivot.remarks },
        };
        // return { [item.id]: { remarks: item.pivot.remarks}}
      }, []);
    });

    fd.append('linked_modules', JSON.stringify(linked_modules));

    let assigned_subtasks = [];
    if (
      this.formData.assigned_subtasks &&
      this.formData.assigned_subtasks.length > 0
    ) {
      assigned_subtasks = this.formData.assigned_subtasks.map((row) => {
        return {
          text: row.text,
          done: row.done,
        };
      });
    }
    fd.append('assigned_subtasks', JSON.stringify(assigned_subtasks));

    if (this.formData.attachments) {
      fd.append('attachments', JSON.stringify(this.formData.attachments));
    }

    this.filesToUpload.forEach((file) => {
      fd.append('file[]', file.file);
    });

    if (this.designPipelines.length) {
      const pipelines = [];
      this.designPipelines.forEach((rp :any) => {
        if (rp.pipeline_id) {
          pipelines.push({
            pipeline_id: rp.pipeline_id,
            pipeline_stage_id: rp.pipeline_stage_id,
            priority: rp.priority,
          });
        }
      });
      fd.append('pipelines', JSON.stringify(pipelines));
    }

    // check for static tags
    if (this.staticTags && this.staticTags.length > 0) {
      const staticTagValues :any = [];
      this.staticTags.forEach((tag :any) => {
        if (tag.selectedValues && tag.selectedValues.length > 0) {
          staticTagValues.push({
            tag_id: tag.id,
            values: tag.selectedValues,
          });
        }
      });
      fd.append('static_tag_ids', JSON.stringify(staticTagValues));
    }

    // return;
    // console.log(fd);

    this.loading = true;
    if (this.design) {
      this.productDesignSvc.updateproductDesign(this.design.id, fd).subscribe(
        (resp) => {
          // console.log(resp);
          this.toastr.success('Updated successfully.');
          this.loading = false;
          this.activeModal.close(resp);
          this.cd.detectChanges();
        },
        (err) => {
          // console.log(err);
          this.toastr.error(
            'Error saving record. Try again later or contact support.',
          );
          this.loading = false;
          this.cd.detectChanges();
        },
      );
    } else {
      this.productDesignSvc.createproductDesign(fd).subscribe(
        (resp) => {
          this.toastr.success('Created successfully.');
          this.loading = false;
          this.activeModal.close(resp);
          this.cd.detectChanges();
        },
        (err) => {
          this.toastr.error(
            'Error saving record. Try again later or contact support.',
          );
          this.loading = false;
          this.cd.detectChanges();
        },
      );
    }
  }

  addLink(link) {
    this.linksToUpload.push(link);
    link = '';
  }

  handleFileInput(event :any) {
    const files = Array.prototype.slice.call(event.target.files);
    // this.filesToUpload = this.filesToUpload.concat(files);
    const kani = this;
    let maxSizeError = false;

    files.forEach((file, idx) => {
      if (file.size > 26214400) {
        maxSizeError = true;
      } else {
        const ftu :any = {
          previewSrc: '',
          file: file,
        };
        this.filesToUpload.push(ftu);
        if (file.type.toString().search('image') >= 0) {
          const index = this.filesToUpload.length - 1;
          const fReader = new FileReader();
          fReader.readAsDataURL(file);
          fReader.onload = function (e :any) {
            kani.filesToUpload[index].previewSrc = e.target.result;
          };
        }
      }
    });
    if (maxSizeError) {
      Swal.fire({
        title: this.translate.instant('MESSAGES.FILE_MAX_SIZE_ERROR.TITLE'),
        text: this.translate.instant('MESSAGES.FILE_MAX_SIZE_ERROR.TEXT'),
        type: 'error',
        confirmButtonText: this.translate.instant('BUTTONS.OKAY'),
      });
    }
    event.target.value = '';
  }

  trackByFn(item :any) {
    return item.id;
  }

  private loadRfqs() {
    this.rfq$ = concat(
      of([]), // default items
      this.rfqInput$.pipe(
        distinctUntilChanged(),
        debounceTime(1000),
        tap(() => (this.rfqLoading = true)),
        switchMap((term) =>
          this.rfqSvc.search({ sku: term }).pipe(
            catchError(() => of([])), // empty list on error
            tap(() => (this.rfqLoading = false)),
            map((resp) => resp),
          ),
        ),
      ),
    );

    this.kit$ = concat(
      of([]), // default items
      this.kitInput$.pipe(
        distinctUntilChanged(),
        debounceTime(1000),
        tap(() => (this.kitLoading = true)),
        switchMap((term) =>
          this.kitSvc.search({ sku: term }).pipe(
            catchError(() => of([])), // empty list on error
            tap(() => (this.kitLoading = false)),
            map((resp) => {
              return resp;
            }),
          ),
        ),
      ),
    );

    this.client$ = concat(
      of([]), // default items
      this.clientInput$.pipe(
        distinctUntilChanged(),
        debounceTime(1000),
        tap(() => (this.clientLoading = true)),
        switchMap((term) =>
          this.clientSvc.search(term).pipe(
            catchError(() => of([])), // empty list on error
            tap(() => (this.clientLoading = false)),
          ),
        ),
      ),
    );

    this.purchaseOrder$ = concat(
      of([]), // default items
      this.purchaseOrderInput$.pipe(
        distinctUntilChanged(),
        debounceTime(1000),
        tap(() => (this.purchaseOrderLoading = true)),
        switchMap((term) =>
          this.poService.search({ po_number: term }).pipe(
            catchError(() => of([])), // empty list on error
            tap(() => (this.purchaseOrderLoading = false)),
          ),
        ),
      ),
    );

    this.clientPo$ = concat(
      of([]), // default items
      this.clientPoInput$.pipe(
        distinctUntilChanged(),
        debounceTime(1000),
        tap(() => (this.clientPoLoading = true)),
        switchMap((term) =>
          this.clientPoService.search({ id: term }).pipe(
            catchError(() => of([])), // empty list on error
            tap(() => (this.clientPoLoading = false)),
          ),
        ),
      ),
    );

    this.clientUser$ = concat(
      of([]), // default items
      this.clientUserInput$.pipe(
        distinctUntilChanged(),
        debounceTime(1000),
        tap(() => (this.clientUserLoading = true)),
        switchMap((term) =>
          this.clientUserService.search({ keyword: term }).pipe(
            catchError(() => of([])), // empty list on error
            tap(() => (this.clientUserLoading = false)),
          ),
        ),
      ),
    );

    this.factory$ = concat(
      of([]), // default items
      this.factoryInput$.pipe(
        distinctUntilChanged(),
        debounceTime(1000),
        tap(() => (this.factoryLoading = true)),
        switchMap((term) =>
          this.factoryService.search({ keyword: term }).pipe(
            catchError(() => of([])), // empty list on error
            tap(() => (this.factoryLoading = false)),
          ),
        ),
      ),
    );
  }

  // private loadRfqs() {
  //     this.rfq$ = concat(
  //         of([]), // default items
  //         this.rfqInput$.pipe(
  //             distinctUntilChanged(),
  //             debounceTime(1000),
  //             tap(() => this.rfqLoading = true),
  //             switchMap(term => this.rfqSvc.searchSKU({ sku: term, kit: 1, allAlternateSkus: 0, is_discontinued: 2 }).pipe(
  //                 catchError(() => of([])), // empty list on error
  //                 tap(() => this.rfqLoading = false)
  //             ))
  //         )
  //     );
  // }

  private loadSelectedRfqs(ids) {
    this.rfq$ = this.rfqSvc.getAsync({ ids: ids }).pipe(
      catchError(() => of([])), // empty list on error
      tap(() => (this.rfqLoading = false)),
      map((resp) => resp.data),
    );
  }

  setStages(idx :number) {
    const p = this.designPipelines[idx];
    const pipeline = this.pipelines.find(
      (row) => row.id == this.designPipelines[idx].pipeline_id,
    );
    if (pipeline) {
      this.designPipelines[idx].stages = pipeline.stages;
      this.designPipelines[idx].pipeline_stage_id = pipeline.stages[0].id;
    }
  }

  addPipeline(designPipeline ?:any) {
    if (designPipeline) {
      this.designPipelines.push(designPipeline);

      return;
    }

    this.designPipelines.push({
      pipeline_id: 0,
      pipeline_stage_id: 0,
      stages: [],
    });
  }

  customTagsSearchFn(term :any, item :any) {
    term = term.toLocaleLowerCase();

    return item.name
      .toLowerCase()
      .replace(/&nbsp;/gi, '')
      .includes(term);
  }

  cancelSubtaskItem() {
    this.formData.assigned_subtasks.map((subtask, i) => {
      this.formData.assigned_subtasks[i].editable = false;
    });

    this.formData.assigned_subtasks.map((subtask, i) => {
      if (
        this.subtask_form_handler[i].text == null ||
        this.subtask_form_handler[i].text == ''
      ) {
        //new
        this.formData.assigned_subtasks.splice(i, 1);
      } else {
        //existing
        this.formData.assigned_subtasks[i].text = this.subtask_form_handler[i].text;
      }
    });

    this.subtask_form_handler = JSON.parse(
      JSON.stringify(this.formData.assigned_subtasks),
    );
  }

  addSubtaskItem() {
    this.formData.assigned_subtasks = JSON.parse(
      JSON.stringify(this.subtask_form_handler),
    );
    this.cancelSubtaskItem();
    const item = {
      id: null,
      text: null,
      editable: true,
      done: false,
    };
    this.formData.assigned_subtasks.push(item);
    this.subtask_form_handler = JSON.parse(
      JSON.stringify(this.formData.assigned_subtasks),
    );
  }

  editSubtaskItem(index) {
    this.cancelSubtaskItem();
    this.formData.assigned_subtasks[index].editable = true;
  }

  saveSubtaskItem(index) {
    if (
      this.formData.assigned_subtasks[index].text == null ||
      this.formData.assigned_subtasks[index].text == ''
    ) {
      this.formData.assigned_subtasks.splice(index, 1);
    } else {
      this.formData.assigned_subtasks[index].editable = false;
    }
    this.subtask_form_handler = JSON.parse(
      JSON.stringify(this.formData.assigned_subtasks),
    );
  }

  deleteSubtaskItem(index) {
    this.formData.assigned_subtasks.splice(index, 1);
    this.subtask_form_handler = JSON.parse(
      JSON.stringify(this.formData.assigned_subtasks),
    );
  }

  toggleCheckbox(index) {
    this.cancelSubtaskItem();
  }

  addToModule(module :string) {
    if (!this.selected[module]) return;

    this.formData.linked_modules[module] = [
      ...this.formData.linked_modules[module],
      { ...this.selected[module], pivot: { remarks: '' } }, // for remarks
    ];

    this.selected[module] = null;
  }

  removeFromModule(module :string, idx :number) {
    this.formData.linked_modules[module] = [
      ...this.formData.linked_modules[module].slice(0, idx),
      ...this.formData.linked_modules[module].slice(idx + 1),
    ];
  }

  createRfqForClient() {
    const modalRef = this.modalSvc.open(CreateClientRfqComponent, {
      size: 'lg',
      windowClass: 'xl1024',
    });
    modalRef.componentInstance.product_type = 1;
    modalRef.result.then(
      (resp :any) => {
        if (resp && resp.id) {
          this.formData.linked_modules.rfqs = [
            ...this.formData.linked_modules.rfqs,
            {
              id: resp.id,
              product_name: resp.product_name,
              internal_sku: resp.internal_sku,
              pivot: { remarks: '' },
            },
          ];

          this.cd.detectChanges();
        }
      },
      (_) => {},
    );
  }

  createClient() {
    const modalRef = this.modalSvc.open(ClientFormComponent, {
      size: 'lg',
    });
    modalRef.result.then(
      (resp :any) => {
        // console.log(resp);
        if (resp && resp.id) {
          this.formData.linked_modules.clients = [
            ...this.formData.linked_modules.clients,
            {
              id: resp.id,
              business_name: resp.business_name,
              user: resp.user
                ? {
                    id: resp.user.id,
                    firstname: resp.user.firstname,
                    lastname: resp.user.lastname,
                  }
                : null,
              pivot: { remarks: '' },
            },
          ];

          this.cd.detectChanges();
        }
      },
      (_) => {},
    );
  }

  createPurchaseOrder() {
    const modalRef = this.modalSvc.open(PurchaseOrderFormComponent, {
      size: 'lg',
      windowClass: 'po-form-modal',
    });

    modalRef.result.then(
      (resp :any) => {
        // console.log(resp);
        if (resp && resp.id) {
          this.formData.linked_modules.purchase_orders = [
            ...this.formData.linked_modules.purchase_orders,
            {
              id: resp.id,
              order_date: resp.order_date,
              pivot: { remarks: '' },
            },
          ];

          this.cd.detectChanges();
        }
      },
      (_) => {},
    );
  }

  createClientPO() {
    const modalRef = this.modalSvc.open(ClientPurchaseOrderPopupFormComponent, {
      size: 'lg',
      windowClass: 'xl1024',
    });
    modalRef.result.then(
      (resp :any) => {
        if (resp && resp.id) {
          this.formData.linked_modules.client_purchase_orders = [
            ...this.formData.linked_modules.client_purchase_orders,
            {
              id: resp.id,
              order_date: resp.order_date,
              pivot: { remarks: '' },
            },
          ];

          this.cd.detectChanges();
        }
      },
      (_) => {},
    );
  }

  createClientUser() {
    const modalRef = this.modalSvc.open(ClientUserPopupForm, {
      size: 'lg',
    });
    modalRef.result.then(
      (resp :any) => {
        if (resp && resp.id) {
          this.formData.linked_modules.client_users = [
            ...this.formData.linked_modules.client_users,
            {
              id: resp.id,
              firstname: resp.firstname,
              lastname: resp.lastname,
              email: resp.email,
              pivot: { remarks: '' },
            },
          ];

          this.cd.detectChanges();
        }
      },
      (_) => {},
    );
  }

  createFactory() {
    const modalRef = this.modalSvc.open(FactoryModalComponent, {
      size: 'lg',
    });

    modalRef.result.then(
      (resp :any) => {
        if (resp && resp.id) {
          this.formData.linked_modules.factories = [
            ...this.formData.linked_modules.factories,
            {
              id: resp.id,
              factory_name: resp.factory_name,
              pivot: { remarks: '' },
            },
          ];

          this.cd.detectChanges();
        }
      },
      (_) => {},
    );
  }

  addDescription(description ?:any) {
    if (description) {
      this.formData.additional_descriptions.push(description);
    } else {
      this.formData.additional_descriptions.push({
        title: 'Title',
        text: '',
      });

      this.activeDescriptionTab = this.formData.additional_descriptions.length;
    }
  }

  removeDescription(index :number) {
    this.formData.additional_descriptions.splice(index, 1);

    this.activeDescriptionTab = index;
  }

  handleDescriptionInput(event :KeyboardEvent) :void {
    event.stopPropagation();
  }

  checkDateIfValid() {
    if (!this.formData.due_date || !this.formData.project_type_id) {
      this.invalidDueDate = false;

      return;
    }

    const projectType = this.projectTypes.find(
      (e) => e.id === this.formData.project_type_id,
    );

    if (
      this.calculateDateDiff(this.formData.due_date) < projectType.lead_time_days
    ) {
      this.invalidDueDate = true;
    } else {
      this.invalidDueDate = false;
    }

    this.cd.detectChanges();
  }

  calculateDateDiff(date) {
    const currentDate = new Date();
    const dateSent = new Date(date);

    const days = Math.floor(
      (Date.UTC(dateSent.getFullYear(), dateSent.getMonth(), dateSent.getDate()) -
        Date.UTC(
          currentDate.getFullYear(),
          currentDate.getMonth(),
          currentDate.getDate(),
        )) /
        (1000 * 60 * 60 * 24),
    );

    return days;
  }

  getSubCategories() {
    this.selectedCategory = {};
    const category :any = this.productCategoriesSvc.getProductCategoryById(
      this.formData.category_id,
    );
    if (!category || category.length == 0) {
      setTimeout(() => {
        this.getSubCategories();
      }, 500);
    }
    if (category && category.length > 0) {
      this.selectedCategory = category[0];
    }
  }

  updateEstimatedDueDate() {
    if (!this.formData.project_type_id) {
      return;
    }

    const projectType = this.projectTypes.find(
      (e) => e.id === this.formData.project_type_id,
    );

    const result = new Date();
    result.setDate(result.getDate() + projectType.lead_time_days);

    return result;
  }
}
